module.exports = __webpack_public_path__ + "img/game.dd69f233.png";